import { render, staticRenderFns } from "./Resolution.vue?vue&type=template&id=e9d46038&lang=pug&"
import script from "./Resolution.vue?vue&type=script&lang=ts&"
export * from "./Resolution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports